interface SelectInputProps {
  label?: string;
  disabled?: boolean;
  required?: boolean;
  error?: string | false | undefined | string[];
  value?: string | string[] | number;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLSelectElement>) => void;
  name?: string;
  placeholder?: string;
  options?: { value: string | number; label: string }[];
}

const SelectInput: React.FC<SelectInputProps> = ({
  label,
  disabled,
  required,
  error,
  onBlur,
  onChange,
  value,
  options,
  placeholder,
  name,
}) => {
  return (
    <div className="max-w-lg">
      {label && (
        <label
          htmlFor={name}
          className="block text-sm text-black mb-1 font-bold"
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <select
        name={name}
        id={name}
        value={value || ""}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        className="input w-full pr-12 py-2 px-3 border rounded-lg bg-gray-100"
      >
        <option value="" disabled>
          {placeholder || "Please select"}
        </option>
        {options?.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <div className="text-red-500 text-xs mt-1">{error}</div>}
    </div>
  );
};

export default SelectInput;
